export const userStatus = {
  active: 1,
  inActive: 2
}

const getStatusList = () => {
  var statusList = [];
  for (var key in userStatus) {
    statusList.push({
      name: key, value: userStatus[key]
    });
  }
  return statusList;
}

export const statusList = getStatusList();

export const getStatusDescription = status => {
  switch(status){
    case 1:
      return "Active";
    default:
      return "Inactive";
  }
}

export const roles = [
  { value: "admin", label: "Administrator"},
  { value: "system-user", label: "System user"},
  { value: "sub-system-user", label: "Sub System user"}
]